
export async function getAllTaxRegime(taxRegimeRepository) {
  return taxRegimeRepository.getAll();
}
